<section class="flex flex-col w-full gap-5 overflow-visible!">
  @if (title()) {
    <section class="flex w-full justify-between items-start min-h-10">
      <div class="flex flex-col gap-1">
        <h2 class="text-xl font-bold text-base-content flex items-center gap-2">
          <span class="w-1 h-6 rounded-full bg-primary"></span>
          {{ title() }}
        </h2>
        @if (subtitle()) {
          <p class="text-sm text-base-content/60">
            {{ subtitle() }}
          </p>
        }
      </div>
      <div class="flex items-center gap-2">
        <ng-content select="[titleActions]" />
        @if (createButtonText()) {
          <button class="btn btn-primary rounded-lg gap-1.5 shadow-sm" (click)="create.emit()">
            <span class="icon-[mdi--plus-circle-outline] text-lg"></span>
            {{ createButtonText() }}
          </button>
        }
      </div>
    </section>
  }
  <ng-content select="[filters]" />
  @if (options()?.header?.show !== false) {
    <lepi-grid-header
      [(align)]="align"
      [(orderBy)]="orderBy"
      [columns]="columns()"
      [rowData]="rowData()"
      [(query)]="query"
      [(selecteds)]="selecteds"
      [hideExcelButton]="hideExcelButton()"
      (export)="handleExport()">
      <ng-content select="[buttons]" />
    </lepi-grid-header>
  }
  @if (options()?.view === 'table' || !options()?.view) {
    <lepi-grid-table [(align)]="align" [(orderBy)]="orderBy" [(selecteds)]="selecteds" />
  } @else {
    <lepi-grid-gallery [(align)]="align" [(orderBy)]="orderBy" />
  }
  <!-- 푸터: 전체 카운트 + 페이지네이션 -->
  <section class="flex w-full justify-between items-center overflow-visible!">
    <p class="text-sm text-base-content/40 font-medium flex items-center gap-1.5">
      전체
      <span class="text-primary font-bold text-base">{{ totalItems() | number }}</span>
      <span class="text-base-content/40">건</span>
    </p>
    @if (!options()?.searchOption?.disablePagination) {
      <div class="flex items-center gap-3 overflow-visible!">
        @if (pageInfo(); as pageInfo) {
          <lepi-pagination [(pageNo)]="pageNo" [pageInfo]="pageInfo" />
        }
        <select
          class="select select-sm select-bordered focus-within:select-primary rounded-lg text-sm h-9 min-h-9 overflow-visible! m-1 focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:relative focus:z-10 min-w-20 pr-8"
          [value]="pageSize()"
          (change)="onPageSizeChange(+$any($event).target.value)">
          <option disabled selected>선택</option>
          @for (size of pageSizeOptions; track size) {
            <option [value]="size">{{ size }}</option>
          }
        </select>
      </div>
    }
  </section>
</section>
